import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Link,
  Card,
  Avatar,
  BodyText,
  CaptionText,
  Icon,
} from '@paypalcorp/pp-react';
import styles from './givingSummaryAction.less';
import * as analytics from '../../lib/analytics';

const GivingSummaryAction = ({ action, defaultFPTITags }) => {
  useEffect(() => {
    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_IMPACT_SUMMARY_ACTION_TILE_SHOWN,
      {
        ...defaultFPTITags,
        e: 'im',
      }
    );
  }, []);

  const trackSummaryActionTileClick = () => {
    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_IMPACT_SUMMARY_ACTION_TILE_PRESSED,
      {
        ...defaultFPTITags,
        e: 'cl',
      }
    );
  };

  const { title, subtitle, icon, logo, url } = action;
  return (
    <Link
      className={styles.actionLink}
      href={url}
      target='_blank'
      rel='noreferrer noopener'
    >
      <Card className={styles.actionCard} onClick={trackSummaryActionTileClick}>
        {icon && <Icon name={icon} size='md' color='sysColorAccent1Main' />}
        {logo && (
          <Avatar className={styles.logo} src={logo} alt='logo' size='sm' />
        )}
        <div className={styles.actionParts}>
          <BodyText className={styles.actionTitle}>{title}</BodyText>
          <CaptionText className={styles.actionSubtitle}>
            {subtitle}
          </CaptionText>
        </div>
      </Card>
    </Link>
  );
};

GivingSummaryAction.propTypes = {
  action: PropTypes.object,
  defaultFPTITags: PropTypes.object,
};

export default GivingSummaryAction;
